import styled from 'styled-components'
import { fadeIn } from 'common'

export const FrequentQuestionSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 50vh;
  flex: 1;
  padding-top: 1rem;
  animation: ${fadeIn} 0.3s ease-out;

  section {
    display: flex;
    padding: 1rem 0;
    flex-direction: column;
    gap: 0.25rem;
  }
`
